module.exports = __webpack_public_path__ + "static/img/sj_banner_bg.dc8ecf0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sj/sj_banner_bg.png
// module id = BwOv
// module chunks = 1